import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../../Entity'
import { formValidationSchemaNoChanged } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'

import {
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_EMPTY_VALUES,
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS,
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_OPTIONS_FILTER_KEY_BY_SCOPE_KEY,
} from './EntityTabBuildingsEditModal.constants'

export function getEntityTabBuildingsEditModalOptionsFilter({
  scopeFilterKey,
  scopeId,
}) {
  const optionsFilterKey =
    ENTITY_TAB_BUILDINGS_EDIT_MODAL_OPTIONS_FILTER_KEY_BY_SCOPE_KEY[
      scopeFilterKey
    ] ?? scopeFilterKey

  return { [optionsFilterKey]: [scopeId] }
}

export function getEntityTabBuildingsEditModalActionTypes() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return [
    actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    actionTypeOptions[EntityActionTypeSelectOptionValue.RemoveAll],
  ]
}

export function getEntityTabBuildingsEditModalInitialValues(buildings) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...ENTITY_TAB_BUILDINGS_EDIT_MODAL_EMPTY_VALUES,
    [ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS]: buildings,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}

export function getEntityTabBuildingsEditModalValidationSchema(initialValues) {
  return formValidationSchemaNoChanged({
    initialValues,
    isEqual: isFormArrayFieldsEqual,
    isEqualProps: {
      name: ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS,
    },
  })
}
